import React from "react";
import { Button, Divider } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../../../app/layout/PageHeader";
import { useStore } from "../../../../app/stores/store";
import { formatCurrency } from "../../../../app/common/util/functions";


interface Props {
  className?: string;
  continueFunc: () => Promise<any>;
  amountDue: number;
}

export default function ApplyARToTicket(props: Props) {
  const { t } = useTranslation(["common", "ticketSettings"]);
  const { modalStore } = useStore();

  return (
    <>
      <PageHeader
        header={t("numbers.notice", { ns: "ticketSettings" })}
        type={"h3"}
        divider={true}
        addTitle={false}
      />
      <p>
        <label className="myLabel fontStyleItalic">
          {t("continueApplyARBeforeAmountDue", { ns: "tickets" })}{formatCurrency(props.amountDue)}{t("continueApplyARAfterAmountDue", { ns: "tickets" })}
        </label>
      </p>
      <Divider />
      <Button
        color="yellow"
        className="save_button"
        content={t("continue", { ns: "tickets" })}
        onClick={async () => {
            await props.continueFunc();
            modalStore.closeModal();
        }}
      />
      <Button
        className="save_button"
        type="button"
        content={t("cancel", { ns: "common" })}
        onClick={() => modalStore.closeModal()}
      />
    </>
  );
}
